import { DEFAULT_CARRIER_SCORE } from 'constants/carriers'

const { bounceRate } = DEFAULT_CARRIER_SCORE

export const getBounceRate = rate => (rate ? 100 - parseInt(rate, 10) : bounceRate)
